import { Inject, Injectable, Injector } from '@angular/core';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { Environment, ENVIRONMENT_TOKEN } from '@brunsker/libs/core/utils/http-log-interceptor/src';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewApiVendasService extends UtilsBaseApiService<NewApiVendasService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('Vendas', injector, environment.BASE_API_URL);
  }

  getTiposDeVenda(): Observable<number[]> {
    return this.httpClient
      .get<number[]>(`${this.BASE_URL}${this.CONTEXT}`);
  }
}
